export default {
    computed: {
        calendarLocale() {
            return this.$texts.getLanguage() === 'nl' ? 'nl-NL' : 'en-US';
        }
    }
}